export default {
  baseStyle: {
    color: 'brand.600',
    textAlign: 'center',
  },
};
